import * as React from 'react';
import { Box, lighten, LinearProgress, Typography,  useTheme,  makeStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';

const useLinearProgressStyles = makeStyles(theme => ({
    colorPrimary: {
        backgroundColor: ({secondaryColor}) => secondaryColor
    },
    barColorPrimary: {
        backgroundColor: ({primaryColor}) => primaryColor
    }
}));

const useTypographyStyles = makeStyles(theme => ({
    root: {
        color: ({primaryColor}) => primaryColor
    }
}));

const getColors = (theme, status) => {
    if (status == 'failed') {
        return {
            primaryColor: theme.palette.error.main,
            secondaryColor: lighten(theme.palette.error.main, 0.5),
        };
    }
    
    return {
        primaryColor: theme.palette.primary.main,
        secondaryColor: lighten(theme.palette.primary.main, 0.5),
    }
} 

export default function UploadProgressBar(props) {
    const { value, status } = props;

    const theme = useTheme();
    const colors = getColors(theme, status);
    const linearProgressClasses = useLinearProgressStyles(colors);
    const typographyClasses = useTypographyStyles(colors);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} classes={linearProgressClasses}/>
            </Box>
            <Box sx={{ minWidth: 35, height: 28 }}>
                {
                    status != 'finished' ?
                    <Typography variant="body2" classes={typographyClasses}>{`${Math.round(
                        value,
                    )}%`}</Typography>
                    :
                    <CheckIcon/>
                }
            </Box>
        </Box>
    );
}
